<template>
  <div>
    <el-dialog
      title="开通乐沃收银"
      :visible="visible"
      @close="handleDialogClose"
      width="380px"
    >
      <div class="dialog">
        <p class="content">请联系总部督导或客服开通乐沃收银</p>
        <div class="flex btns">
          <div class="cat-btn" @click="handleDialogClose">我知道了</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["visible"],
  methods: {
    handleDialogClose() {
      this.$emit("change");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  .content {
    font-size: 14px;
    line-height: 20px;
  }
  .btns {
    padding-top: 10px;
    justify-content: flex-end;
    .cat-btn {
      font-size: 12px;
      background: #07d1aa;
      color: white;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
